import http from '@/app/services/httpServices';
import URL_UTILITY from '@/app/utility/url.utility';

const getWeighMachineData = (context, payload) => {
  return http.getApi(URL_UTILITY.getFaLocationUrl + '/weighing-machine-grid-data', payload);
};
const addEditAdditionalDetail = (context, payload) => {
  return http.postApi(URL_UTILITY.getFaLocationUrl + '/weighing-machine-addtional-attribute', payload);
};
const getAdditionalDataById = (context, payload) => {
  return http.getApi(URL_UTILITY.getFaLocationUrl + '/weighing-machine-get-byid/' + payload.assetId);
};
const getHistoryDataById = (context, payload) => {
  return http.getApi(URL_UTILITY.getFaLocationUrl + '/weighing-machine-history-data', payload);
};
const addEditHistoryDetail = (context, payload) => {
  return http.postApi(URL_UTILITY.getFaLocationUrl + '/weighing-machine-document-id', payload);
};
const deleteDocument = (context, payload) => {
  return http.postApi(URL_UTILITY.getFaLocationUrl + '/update-delete-flag', payload);
};
const getExpiryAlertData = (context, payload) => {
  return http.getApi(URL_UTILITY.getFaLocationUrl + '/weighing-machine-expairy-alert', payload);
};
const getStatusData = (context, payload) => {
  return http.getApi(URL_UTILITY.getFaLocationUrl + '/weighing-machine-status', payload);
};
const getWeighingDashboardData = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getFaLocationUrl + '/weighing-machine-dash', payload
  );
};
const getDashboardDetails = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getFaLocationUrl + '/weighing-machine-dash-dtl', payload
  );
};
const getSummaryData = (context, payload) => {
  return http.getApi(
    URL_UTILITY.getFaLocationUrl + '/weighing-machine-summary-data', payload
  );
};
export default {
    getWeighMachineData,
    addEditAdditionalDetail,
    getAdditionalDataById,
    getHistoryDataById,
    addEditHistoryDetail,
    deleteDocument,
    getExpiryAlertData,
    getStatusData,
    getWeighingDashboardData,
    getDashboardDetails,
    getSummaryData
};
